// extracted by mini-css-extract-plugin
export default {"CreateSalaryRange":"create-salary-range_CreateSalaryRange__AGcsK"};